Vendd.Scripts.load(function () {

	var $wrappers = $('.js-export-file');

	if ($wrappers.length < 1) return;

	initListingExports();

	function initListingExports() {
		var links = $('.js-download-listing', $wrappers);

		links.on('click', function (e) {
			var $this = $(this);
			if (!$this.hasClass('loaded')) {
				if ($this.hasClass('loading')) {
					return false;
				}
				var $container = $this.closest('.js-export-file');
				var data = {
					exportCode: $container.data('export-code') || 'export_default',
					listingId:  $container.data('listing-id') ? "" + $container.data('listing-id') : 'none'
				};

				Vendd.MessageBus.publishAsync($container.get(0), new Vendd.Export.Messages.GetListingExport(data));
				$container.addClass('called');
				$this.addClass('loading');
			}
		});

		Vendd.MessageBus.subscribe(Vendd.Export.Messages.GetListingExportSuccess, Vendd.Export, function (envelope) {

			var container = $('.js-export-file.called'),
				link = $('.js-download-listing', container);

			container.removeClass('called loading');

			var today = new Date(), dd = today.getDate(), mm = today.getMonth() + 1, yyyy = today.getFullYear(),
				data = envelope.message.data, opt = { type: "application/vnd.ms-excel" };

			if (dd < 10) { dd = '0' + dd; }
			if (mm < 10) { mm = '0' + mm; }
			today = dd + '/' + mm + '/' + yyyy;

			var fname = container.data('listing-code') ? (link.html() + '-' + container.data('listing-code') + '.xls') : (link.html() + + '-' + today + '.xls'),
				blb = new Blob([toArrayBuffer(data._buffer)], opt), file = new File([blb], fname);

			link.attr('href', URL.createObjectURL(file));
			link.attr('download', file.name);
			link.addClass('loaded').removeClass('loading');

			link.get(0).click();

		});

		Vendd.MessageBus.subscribe(Vendd.Export.Messages.GetListingExportFailure, Vendd.Export, function (envelope) {
			links.remove();
		});
	};


});
